import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import contentSlice from './slices/contentSlice';
import notificationSlice from './slices/notificationSlice';
import creditsSlice from './slices/creditsSlice';
import devicesSlice from './slices/devicesSlice';
import brandingSlice from './slices/brandingSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    content: contentSlice,
    notifications: notificationSlice,
    credits: creditsSlice,
    devices: devicesSlice,
    branding: brandingSlice
  }
});